import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`

    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        outline: 0;
        font-family: 'Source Code Pro', monospace;

    }

    :root {
        --black-default: #282828;
        --primary-color: #FFFAFA;
        --primary-color-with-transparency: RGBA(255,250,250,0.8);
        --secondary-color: #152044;
        --tertiary-color-main-buttons: #9F2644;
        --details-color: #FCC75B;
        --disponible-hu: #34C600;
        --ocuped-hu: #FA3E3E;
        --reserved-hu: #FF7D12;
        --maintenance-hu: #7700AF;
        --default-text: 'Source Code Pro', monospace;
    }

    body {
        margin: 0;
        padding: 0;
        background-color: var(---primary-color);
        font-family: Open-Sans, Helvetica, Sans-Serif;
    }

    button{
        cursor: pointer;
    }

    ul {
        list-style: none;
    }
`;
